interface Props {
  fullScreen?: boolean;
  size?: number;
}

export default function LoadingSpinner({ fullScreen = false, size = 40 }: Props) {
  const spinner = (
    <div
      className="animate-scanpay-spin rounded-full border-[3px] border-outline-variant border-t-primary-container"
      style={{ width: size, height: size }}
      aria-hidden
    />
  );

  if (!fullScreen) return spinner;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
      {spinner}
    </div>
  );
}
